import { useQuery } from "@tanstack/react-query";
import { api } from "utils/api";
import { FeeAccount } from "../../../components/elements/FeeTab/models/fee-account";

async function fetchXeroFeeAccounts(loanId: string, category: string): Promise<FeeAccount[]> {
  const response = await api.get<FeeAccount[]>("/xero/accounts", {
    params: {
      loanId,
      category,
    },
  });
  return response.data;
}

export const getXeroAccountsQueryKey = (loanId: string, category: string) => [
  "xero-fee-accounts",
  loanId,
  category,
];

export function useXeroAccountsQuery(loanId: string, category: "fee") {
  return useQuery({
    queryKey: getXeroAccountsQueryKey(loanId, category),
    queryFn: () => fetchXeroFeeAccounts(loanId, category),
  });
}
